import styled from 'styled-components'
import Flex from 'components/priority/Flex/Flex'
import floatingMenu from 'styles/floatingMenu'

export const Menu = styled(Flex)`
  overflow-y: auto;
  ${floatingMenu}
`
